<app-loader *ngIf="isLoading"></app-loader>
<div class="d-none d-md-block">
  <div class="d-flex flex-wrap align-items-center mb-3 topHeading">
    <div class="me-2 userDevice-div" data-toggle="tooltip" title="{{userName}} {{name}}">
      <div class="mb-0 fw-bold-new">{{userName}} {{name}} devices / <span class="top-devicename"> {{deviceName}}</span>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-between flex-wrap align-items-center mt-1">
    <div class="d-flex justify-content-between align-items-center mb-2 d-none d-md-block">
      <div class="ms-2 d-flex align-items-center">
        <div class="mb-0 name">
          <span><img src="../../../assets/images/backarrow.png" (click)="goBack()" alt=""
              class="me-1 cursor-pointer" /></span>
          {{deviceName}}
        </div>
      </div>
    </div>

    <div class="ms-auto mt-3 mt-md-0">
      <form [formGroup]="restorePublishForm">
        <ng-select #deviceSelect [dropdownPosition]="'bottom'" class="bg-transparent custom w-100"
          formControlName="mobileDeviceName" [items]="devicesList" bindLabel="deviceName" bindValue="id"
          [clearable]=false [searchable]=false (ngModelChange)="onMobileDeviceSelect($event)">
          <ng-template class="text-truncate custom" ng-label-tmp let-item="item">
            <span class="ps-2">{{item?.deviceName?.length > 15 ?item?.deviceName.slice(0,15) + "..." :
              item?.deviceName}}</span>
          </ng-template>
          <ng-template class="text-truncate custom" ng-option-tmp let-item="item" let-index="index">
            <span title={{item?.deviceName}}>{{ item?.deviceName.length > 15 ? item?.deviceName.slice(0,15) + "..."
              :
              item?.deviceName}}</span>
          </ng-template>
        </ng-select>
      </form>
    </div>
  </div>


  <div class=" date mx-4  mb-3 ms-5" *ngIf="lastSyncDate != null">
    {{"MANAGEDEVICE.LASTUPDATEDON"|translate}} {{lastSyncDate}}
  </div>


  <div class="row mt-4 mb-5">
    <div class="col-12">
      <div class="mng-device-tabs">
        <ul class="nav nav-tabs bg-white reportTabs manage-navtabs">
          <li class="nav-item">
            <a href="#tabs-home" class="nav-link" id="tabs-home-tab" data-bs-toggle="pill"
              (click)="openTabs('MYDEVICE')" [class.active]="openMyDeviceContent" data-bs-target="#tabs-home" role="tab"
              aria-controls="tabs-home" aria-selected="true">{{ "MANAGEUSER.SECURITY" | translate }} ({{
              securityRecommendations.length }})
            </a>
          </li>

          <li class="nav-item ms-4">
            <a href="#tabs-profile" class="nav-link" id="tabs-profile-tab" (click)="openTabs('USERDEVICES')"
              [class.active]="openUserDeviceContent" data-bs-toggle="pill" data-bs-target="#tabs-profile" role="tab"
              aria-controls="tabs-profile" aria-selected="false">{{ "MANAGEUSER.PRIVACY" | translate }} ({{
              privacyRecommendations&&privacyRecommendations.length }})
            </a>
          </li>
        </ul>
      </div>
      <div class="mt-3 shadow-md shadow p-md-2 p-3 q-vertical-content border-radius-6 " *ngIf="openMyDeviceContent">
        <div class="card-body p-0 p-md-0">
          <div class="d-flex flex-wrap justify-content-center py-md-4">
            <div class="mx-4 ">
              <div>
                <div class="fw-bold score-heading d-flex justify-content-center">
                  {{ Securitystringstatus }}
                </div>
              </div>
              <div *ngIf="securityScore != 1000">
                <p class="mb-0">
                  {{ "MANAGEUSER.RECOMMENDATIONALERT" | translate }}
                </p>
              </div>
              <div class="text-center">
                <!-- <rg-gauge-chart [canvasWidth]="canvasWidth" [needleValue]="delimiterPrivacyvalue"
                [centralLabel]="centralLabel" [options]="options1"></rg-gauge-chart> -->
                <div class="d-flex justify-content-center align-items-center mt-4 mb-3">
                  <div class="guage_outer">
                    <div class="guage_inner">
                      <div class="semi_guage">
                        <div class="guage_fil" [style.background]="securityStatusClr"
                          [ngStyle]="{ 'transform': 'rotate(0deg) translate(0,0) rotate('+security_rot_deg+'deg)' }">
                        </div>
                      </div>
                      <div class="guage_cover">
                        <p><span class="score_text" [style.color]="securityStatusClr">{{ securityScore }}</span><br>
                          <span class="score_out_text">{{ "DASHBOARD.OUTOF" |translate }} {{securityTotalScore}}</span>
                        </p>
                      </div>
                      <div class="guage_pill">
                        <div class="mt-0"><span class="guage_pill_text_inline" [style.color]="securityStatusClr"><span
                              style="padding-bottom: 0px;"><img [src]=securityScoreIcon alt="" /></span>
                            {{securityScoreStatus |
                            translate}}</span></div>

                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="d-flex align-items-center justify-content-center my-1">
                <div class="fw-bold fs-xl">
                  <span [style.color]="securityStatusClr"> {{securityScore}} </span>
                  <span class="gray-clr fs-14"> {{ "DASHBOARD.OUTOF" |translate }} {{securityTotalScore}} </span>
                </div>
                <br>
              </div> -->

                <!-- <div class="d-flex align-items-center justify-content-center my-1 fw-bold">
                <div class="ms-2">
                  {{securityScoreStatus}}
                </div>
              </div> -->

                <div class="d-flex align-items-center justify-content-center my-1">
                  <span class="badge badge-pill status-text-recommendation "
                    *ngIf="securityRecommendations&&securityRecommendations?.length != 0 || privacyScore == 0">
                    {{ securityRecommendations&&securityRecommendations.length }} {{ "DASHBOARD.RECOMMENDATIONS" |
                    translate
                    }}</span>
                </div>
                <div *ngIf="securityScore == 1000">
                  <span class="badge badge-pill excellent-recommendation"> {{ "DASHBOARD.NOACTION" | translate
                    }}</span>
                </div>

                <div class="score-sync-date  justify-content-center text-xs mt-2" *ngIf="lastSyncDate != null">
                  {{"MANAGEDEVICE.LASTSYNCON"|translate}} {{lastSyncDate}}
                </div>

                <div class="d-flex align-items-center  justify-content-center text-xs  score-sync-date"
                  *ngIf="lastSyncDate == null">
                  {{"MANAGEDEVICE.SCORE_NOT_SYNC"|translate}}
                </div>

                <div class="d-flex justify-content-center align-items-center my-1" *ngIf=" securityScore!=1000">
                  <button type="button" class="score-sync text-xs-score font-weight-700 mt-2"
                    (click)="openSyncScoreModal(deviceId,'SCORE')">
                    {{"MANAGEUSER.SYNCSCORE" | translate}}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-2 ms-4" *ngIf="securityScore != 1000  && securityScore >= 0">
            <div class="row mt-1 ">
              <h4 class="fw-bold" *ngIf="securityRecommendations?.length!=0">
                {{ "DASHBOARD.RECOMMENDATIONS" | translate }}
              </h4>
            </div>
            <div class="new-card-recemendation d-flex p-3 mt-1">

              <img style="height: 21px; width: 21px" src="./assets/images/Vectorrecommend.png"
                class="me-4 ms-2 mb-1 rounded-images-recomend" />

              <p class="mb-4 me-1 recommendmessege ">
                {{"MANAGEUSER.RECOMMENDATIONMESSEGE" | translate}}
              </p>
            </div>
            <div class="card-body d-none d-md-block shadow-md mt-3 p-3 rounded-6 score-text"
              *ngFor="let item of securityRecommendations">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="me-3">
                    <span
                      class="card card-body shadow shadow-md rounded-circle d-flex justify-content-center align-items-center"
                      style="height: 50px; width: 50px">
                      <img style="height: 25px; width: 25px" src="../../../assets/images/scan.png" alt="" />
                    </span>
                  </div>
                  <div>
                    <h5 class="fw-bold-new score-heading">{{ item.title }}</h5>
                    <p class="mb-0 description">
                      {{ item.description }}
                    </p>
                  </div>
                </div>
                <div>
                </div>
              </div>
            </div>

            <div class="d-block d-md-none">
              <div class="accordion mb-5 mt-4 faq-accordion" id="accordionExample">
                <div *ngFor="
                  let item of securityRecommendations;
                  let i = index
                " class="accordion-item bg-white mb-3">
                  <div class="accordion-header mb-0" id="headingOne{{ i }}">
                    <button class="accordion-button shadow-none collapsed relative p-3 bg-white border-0" type="button"
                      data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ i }}" aria-expanded="false"
                      attr.aria-controls="collapseOne{{ i }}">
                      <span class="me-3 d-flex align-items-center">
                        <div
                          class="card card-body shadow shadow-md rounded-circle d-flex justify-content-center align-items-center"
                          style="height: 30px; width: 30px">
                          <img style="height: 15px; width: 15px" src="../../../assets/images/scan.png" alt="" />
                        </div>
                        <h6 class="fw-bold mb-0 ms-2 score-heading">{{ item.title }}</h6>
                      </span>
                    </button>
                  </div>
                  <div id="collapse_{{ i }}" class="accordion-collapse collapse"
                    attr.aria-labelledby="headingOne{{ i }}" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                      <p class="mb-0">
                        {{ item.description }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="openUserDeviceContent" class="mt-3 shadow shadow-md p-md-2 p-3 q-vertical-content border-radius-6 ">
        <div class="card-body p-0 p-md-3">
          <div class="d-flex flex-wrap justify-content-center py-md-2">
            <div class="mx-4 ">
              <div>
                <div class="fw-bold score-heading d-flex justify-content-center">
                  {{Privacystringstatus }}
                </div>
              </div>
              <div *ngIf="privacyScore != 1000">
                <p class="mb-0">
                  {{ "MANAGEUSER.RECOMMENDATIONALERT" | translate }}
                </p>
              </div>
              <div class="text-center">
                <!-- <rg-gauge-chart [canvasWidth]="canvasWidth" [needleValue]="delimiterPrivacyvalue"
                [centralLabel]="centralLabel" [options]="options1"></rg-gauge-chart> -->
                <div class="d-flex justify-content-center align-items-center mt-4 mb-3">
                  <div class="guage_outer">
                    <div class="guage_inner">
                      <div class="semi_guage">
                        <div class="guage_fil" [style.background]="privacyStatusClr"
                          [ngStyle]="{ 'transform': 'rotate(0deg) translate(0,0) rotate('+privacy_rot_deg+'deg)' }">
                        </div>
                      </div>
                      <div class="guage_cover">
                        <p><span class="score_text" [style.color]="privacyStatusClr">{{privacyScore}}</span><br>
                          <span class="score_out_text">{{ "DASHBOARD.OUTOF" | translate }} {{privacyTotalScore}}</span>
                        </p>
                      </div>
                      <div class="guage_pill">
                        <div class="mt-0"><span class="guage_pill_text" [style.color]="privacyStatusClr"><span><img
                                [src]=privacyScoreIcon alt="" /></span>{{privacyScoreStatus |
                            translate}}</span></div>

                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="d-flex align-items-center justify-content-center my-1">
                <div class="fw-bold fs-xl">
                  <span [style.color]="privacyStatusClr"> {{privacyScore}} </span>
                  <span class="gray-clr fs-14"> {{ "DASHBOARD.OUTOF" | translate }} {{privacyTotalScore}} </span>
                </div>
                <br>
              </div> -->

                <!-- <div class="d-flex align-items-center justify-content-center my-1 fw-bold">
                <div class="ms-2">
                  {{privacyScoreStatus}}
                </div>
              </div> -->

                <div class="d-flex align-items-center justify-content-center my-1">
                  <span class="badge badge-pill status-text-recommendation "
                    *ngIf="privacyRecommendations?.length != 0 || privacyScore == 0">
                    {{ privacyRecommendations&&privacyRecommendations.length }} {{ "DASHBOARD.RECOMMENDATIONS" |
                    translate
                    }}</span>
                </div>
                <div *ngIf="privacyScore == 1000">
                  <span class="badge badge-pill excellent-recommendation "> {{ "DASHBOARD.NOACTION" | translate
                    }}</span>
                </div>

                <div class=" score-sync-date  justify-content-center text-xs mt-2" *ngIf="lastSyncDate != null">
                  {{"MANAGEDEVICE.LASTSYNCON"|translate}} {{lastSyncDate}}
                </div>
                <div class="score-sync-date  justify-content-center text-xs " *ngIf="lastSyncDate == null">
                  {{"MANAGEDEVICE.SCORE_NOT_SYNC"|translate}}
                </div>

                <div class="d-flex justify-content-center align-items-center my-1" *ngIf=" privacyScore!=1000">
                  <button type="button" class="score-sync text-xs-score font-weight-700 mt-2"
                    (click)="openSyncScoreModal(deviceId,'SCORE')">
                    {{"MANAGEUSER.SYNCSCORE" | translate}}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="privacyScore != 1000  && privacyScore >= 0">
            <div class="row mt-5 mt-3">
              <h4 class="fw-bold" *ngIf="privacyRecommendations?.length!=0">
                {{ "DASHBOARD.RECOMMENDATIONS" | translate }}
              </h4>
            </div>




            <div class="new-card-recemendation d-flex p-3 mt-1">

              <img style="height: 21px; width: 21px" src="./assets/images/Vectorrecommend.png"
                class="me-4 ms-2 mb-1 rounded-images-recomend" />

              <p class="mb-4 me-1 recommendmessege ">
                {{"MANAGEUSER.RECOMMENDATIONMESSEGE" | translate}}
              </p>
            </div>

            <div class="card-body d-none d-md-block shadow-md mt-3 p-3 rounded-6 score-text"
              *ngFor="let item of privacyRecommendations">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="me-4 rounded-img">
                    <span
                      class="card card-body shadow shadow-md rounded-circle d-flex justify-content-center align-items-center"
                      style="height: 50px; width: 50px">
                      <img style="height: 25px; width: 25px" src="../../../assets/images/scan.png" alt="" />
                    </span>
                  </div>
                  <div>
                    <h5 class="fw-bold-new score-heading">{{ item.title }}</h5>
                    <p class="description mb-0">
                      {{ item.description }}
                    </p>
                  </div>
                </div>
                <div>
                </div>
              </div>
            </div>

            <div class="d-block d-md-none">
              <div class="accordion mb-5 mt-4 faq-accordion" id="accordionExample">
                <div *ngFor="
                  let item of privacyRecommendations;
                  let i = index
                " class="accordion-item bg-white mb-3">
                  <div class="accordion-header mb-0" id="headingOne{{ i }}">
                    <button class="accordion-button shadow-none collapsed relative p-3 bg-white border-0" type="button"
                      data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ i }}" aria-expanded="false"
                      attr.aria-controls="collapseOne{{ i }}">
                      <span class="me-3 d-flex align-items-center">
                        <div
                          class="card card-body shadow shadow-md rounded-circle d-flex justify-content-center align-items-center"
                          style="height: 30px; width: 30px">
                          <img style="height: 15px; width: 15px" src="../../../assets/images/scan.png" alt="" />
                        </div>
                        <h6 class="fw-bold mb-0 ms-2 score-heading">{{ item.title }}</h6>
                      </span>
                    </button>
                  </div>
                  <div id="collapse_{{ i }}" class="accordion-collapse collapse"
                    attr.aria-labelledby="headingOne{{ i }}" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                      <p class="mb-0">
                        {{ item.description }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>






<div class="d-block d-md-none d-lg-none">
  <div class="d-flex flex-wrap align-items-center mb-3 topHeading">
    <div class="me-2 div23" data-toggle="tooltip" title="{{userName}} {{name}}">
      <div class="mb-0 fw-bold-new"> {{ name ? name.slice(0, 7) : '' }}... devices /
        <span class="top-devicename">
          {{deviceName}}</span>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center mt-2">
      <div class="ms-2 d-flex align-items-center">
        <div class="score-mobileview-name me-5 ">
          <span><img src="../../../assets/images/backarrow.png" (click)="goBack()" alt=""
              class="me-1 cursor-pointer" /></span>
          {{ deviceName ? deviceName.slice(0, 7) : '' }}...
        </div>
      </div>
      <div class="ms-auto mt-1 mt-md-0">
        <form [formGroup]="restorePublishForm">
          <ng-select #deviceSelect [dropdownPosition]="'bottom'" class="bg-transparent custom w-100"
            formControlName="mobileDeviceName" [items]="devicesList" bindLabel="deviceName" bindValue="id"
            [clearable]=false [searchable]=false (ngModelChange)="onMobileDeviceSelect($event)">
            <ng-template class="text-truncate custom" ng-label-tmp let-item="item">
              <span class="ps-2">{{item?.deviceName?.length > 15 ?item?.deviceName.slice(0,15) + "..." :
                item?.deviceName}}</span>
            </ng-template>
            <ng-template class="text-truncate custom" ng-option-tmp let-item="item" let-index="index">
              <span title={{item?.deviceName}}>{{ item?.deviceName.length > 15 ? item?.deviceName.slice(0,15) + "..."
                :
                item?.deviceName}}</span>
            </ng-template>
          </ng-select>
        </form>
      </div>
    </div>

    <div class=" date mb-3 ms-5" *ngIf="lastSyncDate != null">
      {{"MANAGEDEVICE.LASTUPDATEDON"|translate}} {{lastSyncDate}}
    </div>
  </div>

  <div class="row mt-4 mb-5">
    <div class="col-12">
      <div class="mng-device-tabs">
        <ul class="nav nav-tabs bg-white reportTabs manage-navtabs">
          <li class="nav-item">
            <a href="#tabs-home" class="nav-link" id="tabs-home-tab" data-bs-toggle="pill"
              (click)="openTabs('MYDEVICE')" [class.active]="openMyDeviceContent" data-bs-target="#tabs-home" role="tab"
              aria-controls="tabs-home" aria-selected="true">{{ "MANAGEUSER.SECURITY" | translate }} ({{
              securityRecommendations.length }})
            </a>
          </li>

          <li class="nav-item ms-4">
            <a href="#tabs-profile" class="nav-link" id="tabs-profile-tab" (click)="openTabs('USERDEVICES')"
              [class.active]="openUserDeviceContent" data-bs-toggle="pill" data-bs-target="#tabs-profile" role="tab"
              aria-controls="tabs-profile" aria-selected="false">{{ "MANAGEUSER.PRIVACY" | translate }} ({{
              privacyRecommendations&&privacyRecommendations.length }})
            </a>
          </li>
        </ul>
      </div>
      <div class="mt-3 shadow-md shadow p-md-2 p-3 q-vertical-content border-radius-6 " *ngIf="openMyDeviceContent">
        <div class="card-body p-0 p-md-0">
          <div class="d-flex flex-wrap justify-content-center py-md-4">
            <div class="mx-4 ">
              <div>
                <div class="fw-bold score-heading d-flex justify-content-center">
                  {{ Securitystringstatus }}
                </div>
              </div>
              <div *ngIf="securityScore != 1000">
                <p class="mb-0 ms-3">
                  {{ "MANAGEUSER.RECOMMENDATIONALERT" | translate }}
                </p>
              </div>
              <div class="text-center">
                <!-- <rg-gauge-chart [canvasWidth]="canvasWidth" [needleValue]="delimiterPrivacyvalue"
                [centralLabel]="centralLabel" [options]="options1"></rg-gauge-chart> -->
                <div class="d-flex justify-content-center align-items-center mt-4 mb-3">
                  <div class="guage_outer">
                    <div class="guage_inner">
                      <div class="semi_guage">
                        <div class="guage_fil" [style.background]="securityStatusClr"
                          [ngStyle]="{ 'transform': 'rotate(0deg) translate(0,0) rotate('+security_rot_deg+'deg)' }">
                        </div>
                      </div>
                      <div class="guage_cover">
                        <p><span class="score_text" [style.color]="securityStatusClr">{{ securityScore }}</span><br>
                          <span class="score_out_text">{{ "DASHBOARD.OUTOF" |translate }} {{securityTotalScore}}</span>
                        </p>
                      </div>
                      <div class="guage_pill">
                        <div class="mt-0"><span class="guage_pill_text" [style.color]="securityStatusClr"><span
                              style="padding-bottom: 10px;"><img [src]=securityScoreIcon alt="" /></span>
                            {{securityScoreStatus |
                            translate}}</span></div>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-center my-1">
                  <span class="badge badge-pill status-text-recommendation "
                    *ngIf="securityRecommendations&&securityRecommendations?.length != 0 || privacyScore == 0">
                    {{ securityRecommendations&&securityRecommendations.length }} {{ "DASHBOARD.RECOMMENDATIONS" |
                    translate
                    }}</span>
                </div>
                <div *ngIf="securityScore == 1000">
                  <span class="badge badge-pill excellent-recommendation"> {{ "DASHBOARD.NOACTION" | translate
                    }}</span>
                </div>

                <div class="score-sync-date  justify-content-center text-xs mt-2" *ngIf="lastSyncDate != null">
                  {{"MANAGEDEVICE.LASTSYNCON"|translate}} {{lastSyncDate}}
                </div>

                <div class="d-flex align-items-center  justify-content-center text-xs  score-sync-date"
                  *ngIf="lastSyncDate == null">
                  {{"MANAGEDEVICE.SCORE_NOT_SYNC"|translate}}
                </div>

                <div class="d-flex justify-content-center align-items-center my-1" *ngIf=" securityScore!=1000">
                  <button type="button" class="score-sync text-xs-score font-weight-700 mt-2"
                    (click)="openSyncScoreModal(deviceId,'SCORE')">
                    {{"MANAGEUSER.SYNCSCORE" | translate}}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-2 ms-4" *ngIf="securityScore != 1000  && securityScore >= 0">
            <div class="row mt-1 ">
              <h4 class="fw-bold" *ngIf="securityRecommendations?.length!=0">
                {{ "DASHBOARD.RECOMMENDATIONS" | translate }}
              </h4>
            </div>
            <div class="new-card-recemendation d-flex p-3 mt-1">
              <img style="height: 16px; width: 16px" src="./assets/images/Vectorrecommend.png"
                class="me-4 ms-2 mb-1 rounded-images-recomend" />
              <p class="mb-4 me-1 recommendmessegemobileview ">
                {{"MANAGEUSER.RECOMMENDATIONMESSEGE" | translate}}
              </p>
            </div>
            <div class="card-body d-none d-md-block shadow-md mt-3 p-3 rounded-6 score-text"
              *ngFor="let item of securityRecommendations">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="me-3">
                    <span
                      class="card card-body shadow shadow-md rounded-circle d-flex justify-content-center align-items-center"
                      style="height: 50px; width: 50px">
                      <img style="height: 25px; width: 25px" src="../../../assets/images/scan.png" alt="" />
                    </span>
                  </div>
                  <div>
                    <h5 class="fw-bold-new score-heading">{{ item.title }}</h5>
                    <p class="mb-0 description">
                      {{ item.description }}
                    </p>
                  </div>
                </div>
                <div>
                </div>
              </div>
            </div>

            <div class="d-block d-md-none">
              <div class="accordion mb-5 mt-4 faq-accordion" id="accordionExample">
                <div *ngFor="
                  let item of securityRecommendations;
                  let i = index
                " class="accordion-item bg-white mb-3">
                  <div class="accordion-header mb-0" id="headingOne{{ i }}">
                    <button class="accordion-button shadow-none collapsed relative p-3 bg-white border-0" type="button"
                      data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ i }}" aria-expanded="false"
                      attr.aria-controls="collapseOne{{ i }}">
                      <span class="me-3 d-flex align-items-center">
                        <div
                          class="card card-body shadow shadow-md rounded-circle d-flex justify-content-center align-items-center"
                          style="height: 30px; width: 30px">
                          <img style="height: 15px; width: 15px" src="../../../assets/images/scan.png" alt="" />
                        </div>
                        <h6 class="fw-bold mb-0 ms-2 score-heading">{{ item.title }}</h6>
                      </span>
                    </button>
                  </div>
                  <div id="collapse_{{ i }}" class="accordion-collapse collapse"
                    attr.aria-labelledby="headingOne{{ i }}" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                      <p class="mb-0">
                        {{ item.description }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="openUserDeviceContent" class="mt-3 shadow shadow-md p-md-2 p-3 q-vertical-content border-radius-6 ">
        <div class="card-body p-0 p-md-3">
          <div class="d-flex flex-wrap justify-content-center py-md-2">
            <div class="mx-4 ">
              <div>
                <div class="fw-bold score-heading d-flex justify-content-center">
                  {{Privacystringstatus }}
                </div>
              </div>
              <div *ngIf="privacyScore != 1000">
                <p class="mb-0 ms-3">
                  {{ "MANAGEUSER.RECOMMENDATIONALERT" | translate }}
                </p>
              </div>
              <div class="text-center">
                <!-- <rg-gauge-chart [canvasWidth]="canvasWidth" [needleValue]="delimiterPrivacyvalue"
                [centralLabel]="centralLabel" [options]="options1"></rg-gauge-chart> -->
                <div class="d-flex justify-content-center align-items-center mt-4 mb-3">
                  <div class="guage_outer">
                    <div class="guage_inner">
                      <div class="semi_guage">
                        <div class="guage_fil" [style.background]="privacyStatusClr"
                          [ngStyle]="{ 'transform': 'rotate(0deg) translate(0,0) rotate('+privacy_rot_deg+'deg)' }">
                        </div>
                      </div>
                      <div class="guage_cover">
                        <p><span class="score_text" [style.color]="privacyStatusClr">{{privacyScore}}</span><br>
                          <span class="score_out_text">{{ "DASHBOARD.OUTOF" | translate }} {{privacyTotalScore}}</span>
                        </p>
                      </div>
                      <div class="guage_pill">
                        <div class="mt-2"><span class="guage_pill_text" [style.color]="privacyStatusClr"><span
                              class="me-2"><img [src]=privacyScoreIcon alt="" /></span>{{privacyScoreStatus |
                            translate}}</span></div>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-center my-1">
                  <span class="badge badge-pill status-text-recommendation "
                    *ngIf="privacyRecommendations?.length != 0 || privacyScore == 0">
                    {{ privacyRecommendations&&privacyRecommendations.length }} {{ "DASHBOARD.RECOMMENDATIONS" |
                    translate
                    }}</span>
                </div>
                <div *ngIf="privacyScore == 1000">
                  <span class="badge badge-pill excellent-recommendation "> {{ "DASHBOARD.NOACTION" | translate
                    }}</span>
                </div>

                <div class=" score-sync-date  justify-content-center text-xs mt-2" *ngIf="lastSyncDate != null">
                  {{"MANAGEDEVICE.LASTSYNCON"|translate}} {{lastSyncDate}}
                </div>
                <div class="score-sync-date  justify-content-center text-xs " *ngIf="lastSyncDate == null">
                  {{"MANAGEDEVICE.SCORE_NOT_SYNC"|translate}}
                </div>

                <div class="d-flex justify-content-center align-items-center my-1" *ngIf=" privacyScore!=1000">
                  <button type="button" class="score-sync text-xs-score font-weight-700 mt-2"
                    (click)="openSyncScoreModal(deviceId,'SCORE')">
                    {{"MANAGEUSER.SYNCSCORE" | translate}}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="privacyScore != 1000  && privacyScore >= 0">
            <div class="row mt-1">
              <h4 class="fw-bold" *ngIf="privacyRecommendations?.length!=0">
                {{ "DASHBOARD.RECOMMENDATIONS" | translate }}
              </h4>
            </div>
            <div class="new-card-recemendation d-flex p-3 mt-1">
              <img style="height: 16px; width: 16px" src="./assets/images/Vectorrecommend.png"
                class="me-4 ms-2 mb-1 rounded-images-recomend" />
              <p class="mb-4 me-1 recommendmessegemobileview ">
                {{"MANAGEUSER.RECOMMENDATIONMESSEGE" | translate}}
              </p>
            </div>
            <div class="card-body d-none d-md-block shadow-md mt-3 p-3 rounded-6 score-text"
              *ngFor="let item of privacyRecommendations">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="me-4 rounded-img">
                    <span
                      class="card card-body shadow shadow-md rounded-circle d-flex justify-content-center align-items-center"
                      style="height: 50px; width: 50px">
                      <img style="height: 25px; width: 25px" src="../../../assets/images/scan.png" alt="" />
                    </span>
                  </div>
                  <div>
                    <h5 class="fw-bold-new score-heading">{{ item.title }}</h5>
                    <p class="description mb-0">
                      {{ item.description }}
                    </p>
                  </div>
                </div>
                <div>
                </div>
              </div>
            </div>

            <div class="d-block d-md-none">
              <div class="accordion mb-5 mt-4 faq-accordion" id="accordionExample">
                <div *ngFor="
                  let item of privacyRecommendations;
                  let i = index
                " class="accordion-item bg-white mb-3">
                  <div class="accordion-header mb-0" id="headingOne{{ i }}">
                    <button class="accordion-button shadow-none collapsed relative p-3 bg-white border-0" type="button"
                      data-bs-toggle="collapse" attr.data-bs-target="#collapse_{{ i }}" aria-expanded="false"
                      attr.aria-controls="collapseOne{{ i }}">
                      <span class="me-3 d-flex align-items-center">
                        <div
                          class="card card-body shadow shadow-md rounded-circle d-flex justify-content-center align-items-center"
                          style="height: 30px; width: 30px">
                          <img style="height: 15px; width: 15px" src="../../../assets/images/scan.png" alt="" />
                        </div>
                        <h6 class="fw-bold mb-0 ms-2 score-heading">{{ item.title }}</h6>
                      </span>
                    </button>
                  </div>
                  <div id="collapse_{{ i }}" class="accordion-collapse collapse"
                    attr.aria-labelledby="headingOne{{ i }}" data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                      <p class="mb-0">
                        {{ item.description }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</div>